<template>
  <div>
    <div class="form-group">
      <label class="control-label" for="instructions">Instructions</label>
      <QuillEditor v-model:content="content.instructions" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>
    <div class="form-group">
      <label class="control-label" for="instructions-text-classes">Instructions CSS Classes</label>
      <input id="instructions-text-classes" v-model="content.instructionsTextClasses" class="form-control" type="text">
    </div>
    <h2 class="mb-4">Drag Sort Items</h2>
    <div class="form-group mb-4">
      <button class="btn btn-default" type="button" @click="addItem()">
        <i class="fa fa-plus"></i> Add Drag Item
      </button>
    </div>
    <template v-if="content.items && content.items.length > 0">
      <ul class="list-group">
        <li v-for="(item, index) in content.items" :key="index" class="list-group-item">
          <div class="d-flex flex-wrap">
            <div class="w-50 p-2">
              <img v-if="item.image" :src="item.image" alt="" class="img-thumbnail mb-2">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <a :data-input="'image-' + index" class="btn btn-primary text-white" data-lfm="image">
                    <i class="fa fa-image"></i>
                  </a>
                </div>
                <input :id="'image-' + index" v-model="item.image" class="form-control" type="text">
              </div>
            </div>
            <div class="w-50 p-2">
              <div class="input-group">
                <label>Item label</label>
                <textarea v-model="item.label" class="form-control mb-2" placeholder="Item Label"></textarea>
              </div>
              <div class="input-group">
                <label>Flow Hook</label>
                <input v-model="item.flow" class="form-control mb-2" placeholder="Flow Hook">
              </div>
            </div>
            <div class="p-2 d-flex w-100 justify-content-end">
              <button class="btn btn-danger" type="button" @click="content.items.splice(index, 1)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
      <div class="form-group mt-4">
        <button class="btn btn-default" type="button" @click="addItem()">
          <i class="fa fa-plus"></i> Add Drag Item
        </button>
      </div>
      <AnimationControlsComponent v-cloak :content="content" :pkey="'draggableEffects'"
                                  :plabel="'Drag Item Animation Controls'"></AnimationControlsComponent>
    </template>
    <h2 class="mb-4">Drop Zones</h2>
    <div class="form-group mb-4">
      <button class="btn btn-default" type="button" @click="addDropZone()">
        <i class="fa fa-plus"></i> Add Drop Zone
      </button>
    </div>
    <template v-if="content.dropzones && content.dropzones.length > 0">
      <ul class="list-group">
        <li v-for="(dropzone, index) in content.dropzones" :key="index" class="list-group-item">
          <div class="d-flex flex-wrap">
            <div class="w-50">
              <div class="input-group">
                <label class="sr-only">Dropzone label</label>
                <input v-model="dropzone.label" class="form-control" placeholder="Dropzone Label" type="text">
              </div>
            </div>
            <div class="p-2 d-flex w-50 justify-content-end">
              <button class="btn btn-danger" type="button" @click="content.dropzones.splice(index, 1)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
      <div class="form-group mt-4">
        <button class="btn btn-default" type="button" @click="addDropZone()">
          <i class="fa fa-plus"></i> Add Drop Zone
        </button>
      </div>
      <AnimationControlsComponent v-cloak :content="content" :pkey="'dropzoneEffects'"
                                  :plabel="'Drop Zone Animation Controls'"></AnimationControlsComponent>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import layoutMixin from '../../mixins/layout'
import {v4 as uuid4} from 'uuid'
import {QuillEditor} from '@vueup/vue-quill'
import AnimationControlsComponent from "../AnimationControlsComponent.vue";

export default {
  mixins: [layoutMixin],
  components: {
    AnimationControlsComponent,
    QuillEditor
  },
  data() {
    const content = _.cloneDeep(this.source)

    if (!_.get(content, 'instructionsTextClasses')) {
      content.instructionsTextClasses = ''
    }

    if (!_.get(content, 'draggableEffects')) {
      content.draggableEffects = {
        animationEffects: {
          responseDisplay: '',
          responseStartDelay: 0,
          responseBetweenDelay: 0.2
        }
      }
    }

    if (!_.get(content, 'dropzoneEffects')) {
      content.dropzoneEffects = {
        animationEffects: {
          responseDisplay: '',
          responseStartDelay: 0,
          responseBetweenDelay: 0.2
        }
      }
    }
    return {
      content: content
    }
  },
  methods: {
    getValue() {
      return this.content
    },
    addItem() {
      if (!this.content.items) {
        this.content.items = []
      }
      this.content.items.push({
        image: '',
        label: '',
        slotLabel: '',
        id: uuid4()
      })
    },
    addDropZone(index) {
      if (!this.content.dropzones) {
        this.content.dropzones = []
      }
      this.content.dropzones.push({
        label: '',
        id: uuid4()
      })
    }
  }
}
</script>
